var crypto = require("crypto");

/**
 * @description generates the encrypted password
 * @param {String} password The password provided by the user
 * @param {Number} iterations Number of iterations from the user's profile
 * @param {String} salt Salt from the user's profile
 * @returns {String} The encrypted password
 */
module.exports = function (password, iterations, salt) {
    var hash;

    try {
        var saltBuffer = Buffer.from(salt, "hex");
        var key = crypto.pbkdf2Sync(password, saltBuffer, iterations, 64, "sha1");
        hash = key.toString("hex");
    } catch (e) {
        // allows the flow to continue, which will do proper validation
        hash = "not_available";
    }

    return hash;
};
